<!-- 星币明细 -->
<template>
  <div class="component-page">
    <div class="filter">
      <el-date-picker
        v-model="formParams.date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placement="bottom-start"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        @change="methodChangeDate"
      >
      </el-date-picker>
    </div>
    <div class="table">
      <el-table
        size="small"
        :data="tableData"
        :header-row-style="{
          'border-radius': '5px',
          overflow: 'hidden',
        }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }"
        stripe
      >
        <!-- <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no - 1) * 20 }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          v-for="item in tableTitle"
          :key="item.value"
          :value="item.value"
          :label="item.label"
          :align="item.align"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div
              v-if="item.value === 'orderState'"
              style="display:flex;justify-content:center;align-items:center"
            >
              <i
                :style="{
                  display: 'inline-flex',
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                  marginRight: '5px',
                  backgroundColor:
                    scope.row.orderState === 0
                      ? '#2488ef'
                      : scope.row.orderState === 1
                      ? '#e4393c'
                      : '#17A81C',
                }"
              ></i>
              <span>
                {{ stateMap[scope.row[item.value]] }}
              </span>
            </div>
            <div v-else-if="item.value === 'operation'">
              <el-button
                type="text"
                size="mini"
                @click="methodExchangeDialog(scope.row)"
              >
                查看订单
              </el-button>
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
// 引入请求
import { api_stuStarGrantQueryList } from '@/api/javaApi'

export default {
  name: 'fetchRecord',
  props: ['pageInfo'],
  data() {
    return {
      formParams: {
        date: null,
      },
      tableTitle: [
        { label: '场景', value: 'scene' },
        { label: '来源', value: 'sourceName' },
        { label: '标签', value: 'tagName' },
        { label: '星币数量', value: 'starNum' },
        { label: '时间', value: 'grantTime' },
        { label: '备注', value: 'remark' },
      ],
      tableData: [],
    }
  },
  computed: {
    calcPageInfo() {
      return window.JSON.stringify(this.pageInfo)
    },
  },
  watch: {
    // 直接监听prop新旧值一样，因为是引用类型，所以用计算属性包裹一下变成字符串
    calcPageInfo: {
      handler(newPage, oldPage) {
        if (oldPage !== newPage && window.JSON.parse(newPage).update) {
          this.stuStarGrantQueryList()
        }
      },
    },
  },
  created() {
    this.stuStarGrantQueryList()
  },
  methods: {
    methodChangeDate(date) {
      console.log(date)
      this.$emit('returnPage', {
        currentPage: 1,
      })
      this.stuStarGrantQueryList()
    },
    stuStarGrantQueryList() {
      let startTime = null,
        endTime = null
      if (this.formParams.date) {
        startTime =
          this.formParams.date.length > 0 ? this.formParams.date[0] : null
        endTime =
          this.formParams.date.length > 0 ? this.formParams.date[1] : null
      }
      api_stuStarGrantQueryList({
        stuId: this.$store.state.user.userInfo.id,
        eduCampusId: this.$store.state.user.userInfo.eduCampusId,
        startTime,
        endTime,
        pageRequest: {
          pageNum: this.pageInfo.currentPage,
          pageSize: this.pageInfo.pageSize,
        },
      }).then((res) => {
        console.log(res)
        this.tableData = res.content
        this.tableData.forEach((item) => {
          item.starNum = item.starNum < 0 ? item.starNum : '+' + item.starNum
          item.sourceName = item.sourceName || '--'
        })
        this.$emit('returnPage', {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
          update: false,
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
.component-page {
  padding: 20px 40px 40px;
  background-color: #fff;
  border-radius: 10px;
  .filter {
    display: flex;
    margin-bottom: 25px;
  }
}
</style>
